export const BASE_URL_IMAGEN = process.env.REACT_APP_BASE_URL;
export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const API_ROUTES = {
    EXTRACTOS: BASE_URL + 'extracto/',
    EXTRACTOREGISTRO: BASE_URL + 'extracto-registro/',
    TIPOSORTEO: BASE_URL + 'tipo-sorteo/',
    IMAGEN: BASE_URL + 'imagen/',
    PUBLICACION_EXTRACTO: BASE_URL + 'publicacion/',
    AUTORIDADES: BASE_URL + 'autoridades/',
    ESCRIBANO: BASE_URL + 'escribano/',
    INCIDENTE: BASE_URL + 'incidente/',
    PARAMETROMONTOS: BASE_URL + 'parametro-montos/',
};
